import Vue from 'vue'

const filters = {
  formatCurrency (num) {
    if (num) {
      let number = num.toString()

      if (number === '' || isNaN(number)) {
        return num
      }

      if (number.indexOf('-') > 0) {
        return num
      }

      let sign = number.indexOf('-') === 0 ? '-' : ''
      if (sign === '-') {
        number = number.substr(1)
      }

      let cents = number.indexOf('.') > 0 ? number.substr(number.indexOf('.')) : ''
      cents = cents.length > 1 ? cents : ''

      number = number.indexOf('.') > 0 ? number.substring(0, (number.indexOf('.'))) : number

      if (cents === '') {
        if (number.length > 1 && number.substr(0, 1) === '0') {
          return num
        }
      } else {
        if (number.length > 1 && number.substr(0, 1) === '0') {
          return num
        }
      }

      let tempNum = ''
      while (number.length > 3) {
        tempNum = ',' + number.slice(-3) + tempNum
        number = number.slice(0, number.length - 3)
      }
      if (number) {
        tempNum = number + tempNum
      }

      return (sign + tempNum + cents)
    } else {
      return 0
    }
  },
  pad (num, size) {
    const str = String(num)
    return new Array(size - str.length + 1).join('0') + str
  }
}

Object.keys(filters).forEach(name => Vue.filter(name, filters[name]))

export default filters
